import { AppLayout, Logo } from "uikit"
import HouseholdMenu from "components/HouseholdMenu"
import React, { useCallback } from "react"
import { useStore } from "store"
import { AppMenu } from "./App"
import AppViews from "./AppViews"
import TermsofUse from "components/TermsofUse"
import { ReviewHouseholdBanner, CovidBanner } from "components/AppBanners"
import { useLocation } from "react-router"
import { NavBar } from "components/homescreen/NavBar"

const altLayoutLocations = ["learning", "course", "budgeting", "home"]

const AppHeaderMemo = React.memo(
  ({
    first_name,
    group_id,
    group_type,
    description,
    location,
    agreementsLength,
    env
  }) => {
    return (
      <AppLayout.Header env={env} logo={<Logo />}>
        {group_type === "advisor" ? (
          <HouseholdMenu description={description} />
        ) : (
          !agreementsLength && <NavBar location={location} />
        )}
        {!agreementsLength && (
          <AppMenu first_name={first_name} group_id={group_id} />
        )}
      </AppLayout.Header>
    )
  }
)

const AppLayoutView = ({ logout }) => {
  const location = useLocation()
  const [user, { setCurrentHouseholdId }] = useStore("user")
  const [newAgreements] = useStore("newAgreements")
  const [householdId] = useStore("userState", "currentHouseholdId")
  const [household, { createAndSetupNewHousehold }] = useStore(
    "households",
    householdId
  )
  const [subscription] = useStore("subscriptions", household.id)
  const isCOVID =
    subscription && subscription.features && subscription.features.is_covid
  const [isReviewHousehold] = useStore("isReviewHousehold")

  const setCurrentHousehold = useCallback(
    async household_id => {
      await setCurrentHouseholdId(household_id)
    },
    [setCurrentHouseholdId]
  )

  const altLayout = altLayoutLocations.some(v => location.pathname.includes(v))
  document.getElementsByTagName("body")[0].setAttribute("altLayout", altLayout)

  return (
    <AppLayout style={{ backgroundColor: "white" }}>
      <div className="fakeHeader"></div>
      <AppHeaderMemo
        first_name={user.first_name}
        group_id={user.group_id}
        group_type={user.group_type}
        description={household.description}
        location={location.pathname.split("/")[1]}
        agreementsLength={newAgreements.length}
        env={
          process.env.REACT_APP_DEPLOY_ENV !== "production"
            ? location.hostname === "localhost"
              ? "local"
              : null
            : null
        }
      />
      {isReviewHousehold && (
        <ReviewHouseholdBanner setCurrentHousehold={setCurrentHousehold} />
      )}
      {isCOVID && <CovidBanner />}
      <AppLayout.Content>
        <AppViews
          user={user}
          pathname={location.pathname}
          logout={logout}
          household={household}
          setCurrentHousehold={setCurrentHousehold}
          createHousehold={createAndSetupNewHousehold}
        />
      </AppLayout.Content>
      <AppLayout.Footer disclosure={<TermsofUse />} />
    </AppLayout>
  )
}

export default AppLayoutView
